import { withProps } from 'recompose'
import EmptyTireLinesList from './EmptyTireLinesList'

export default withProps(({ activeVehicle, storePhoneNumber }) => ({
  text: `The selected tires are incompatible with your ${activeVehicle}. Please call your ${storePhoneNumber ? 'local store at ' : ''}`
}))(EmptyTireLinesList)
